import ComponentBase from "@components/ComponentBase";
import { ComponentElem } from "@components/interfaces";
import { Common } from "@root/components/common/CommonTypes";
import { Emitter } from "strict-event-emitter";

export default class CollapseButton extends ComponentBase implements Common.CollapseRelational
{
  _isCollapsed: Boolean;

  emitter: Emitter<{change: [value: string]}>;

  constructor(elem: ComponentElem)
  {
    super(elem);

    this.emitter = new Emitter();

    this._isCollapsed = this.$root.attr("collapsed") === "true";

    this.$root.on("click", (event:JQuery.ClickEvent)=>
    {
      event.preventDefault();
      
      this.toggleCollapse(!this._isCollapsed);
    });
  }

  toggleCollapse(b: boolean)
  {
    this._isCollapsed = b;
    this.$root.attr("collapsed", this._isCollapsed? "true": "false");
    this.emitter.emit("change", this._isCollapsed? "true": "false");
  }
}